import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ExportadoresService } from "./exportadores.service";
import { ExportadoresModel } from "./exportadores.model";
import { Global } from "../global";
import { Components } from "../shared/components/components";
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { Funcoes } from "../funcoes";
import { LoginService } from "../login/login.service";
import { PaisesService } from "../paises/paises.service";

declare var swal, $: any;

@Component({
  selector: 'app-exportadores',
  templateUrl: './exportadores.component.html'
})
export class ExportadoresComponent extends Components implements OnInit {

  exportadores: ExportadoresModel[] = [];
  privilegioUsuario = { "editar": false, "consultar": false };

  formPesquisaAvancada: FormGroup;
  filtroPesquisa = { "nome": "", "id_pais": "" };
  listPaises = [];

  constructor(
    formBuilder: FormBuilder,
    private exportadoresService: ExportadoresService,
    private paisesService: PaisesService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.formPesquisaAvancada = formBuilder.group({
      nome: [],
      id_pais: []
    });

    this.loginService.getUserInfo().subscribe(data => {
      for (let i in data.privilegios) {
        if (data.privilegios[i].id_acao == '26') {
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });

    this.paisesService.get().subscribe(
      res => this.listPaises = res.Payload,
      err => this.func.showErro(err.json())
    );
  }

  ngOnInit() {
    // busca filtro salvo no localStorage
    let filtroSalvo = this.carregaFiltro();
    if (filtroSalvo) {
      this.filtroPesquisa = filtroSalvo;
      this.formPesquisaAvancada.patchValue(filtroSalvo);
    }

    this.getPage(1);
  }

  delete(exportador) {
    let exportadores = this.exportadores;
    let exportadoresService = this.exportadoresService;
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarExportador') + exportador.nome,
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        if (self.global.debug == true) {
          console.log(exportadores);
        }

        let index = exportadores.indexOf(exportador);
        exportadores.splice(index, 1);

        exportadoresService.apagar(exportador.id)
          .subscribe(res => {
            self.exportadores = exportadores;
          },
            err => {
              exportadores.splice(index, 0, exportador);
              self.exportadores = exportadores;
              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina) {
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};
    if (this.filtroPesquisa.nome != '') {
      filtros['nome'] = "**:" + this.filtroPesquisa.nome;
    }
    if (this.filtroPesquisa.id_pais != '') {
      filtros['id_pais'] = this.filtroPesquisa.id_pais;
    }

    this.exportadoresService.getPaginacao(pagina, this.itensPorPagina, ['pais'], filtros)
      .subscribe(data => {
        this.exportadores = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  modalPesquisaAvancada() {
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada() {
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada() {
    this.filtroPesquisa = { "nome": "", "id_pais": "" };
    this.limpaFiltroSalvo();
    this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    this.getPage(1);
  }

}




// WEBPACK FOOTER //
// ./src/app/exportadores/exportadores.component.ts